<template>
  <Layout :background="'gradient'" :no-sidebar="true">
    <Header :no-sidebar="true" />
    <div class="card-started" id="home-card">
      <!--
      Profile
    -->
      <div class="profile">
        <!-- profile image -->
        <div class="slide" :style="backgroundImageInlineStyle"></div>
        <div class="image">
          <img :src="require('../assets/images/chunhakrai.jpeg')" alt="" />
        </div>
        <!-- profile titles -->
        <div class="title">Chunhakrai Buncherdjaruwong</div>
        <!--<div class="typed">Web Designer</div>-->
        <typing-animation />

        <!-- profile socials -->
        <profile-socials />

        <!-- profile buttons -->
        <div class="lnks">
          <a href="#" class="lnk">
            <span class="text">Download CV</span>
          </a>
          <a
            href="#"
            class="lnk discover"
            @click="navFunction.activeSection('contacts')"
          >
            <span class="text">Contact Me</span>
          </a>
        </div>
      </div>
    </div>
    <about />
<!--    <active-section section-name="about"/>-->
    <active-section section-name="resume">
      <experience />
    </active-section>
  </Layout>
</template>

<script>
import Layout from "@/layouts/layout";
import ActiveSection from "@/components/activeSection";
import About from "@/components/about";
import Header from "@/layouts/header";
import Experience from "@/components/experience";
import TypingAnimation from "@/components/typingAnimation";
import ProfileSocials from "@/components/profile-socials";

// import "@/assets/css/new-skin.css";
// import "@/assets/css/demo-color.css";
// import "@/assets/css/dark.css";
// import "@/assets/css/classic-skin.css";

export default {
  name: "homepage",
  components: {
    ProfileSocials,
    TypingAnimation,
    Experience,
    About,
    ActiveSection,
    Layout,
    Header
  },
  computed: {
    backgroundImageInlineStyle() {
      return `background-image: url(${require("../assets/images/code.gif")});`;
    }
  }
};
</script>

<style src="../assets/css/new-skin.css"></style>
<style src="../assets/css/demo-color.css"></style>
<style src="../assets/css/classic-skin.css"></style>
<style src="../assets/css/dark.css"></style>
